module.exports = __webpack_public_path__ + "img/new_p_2.cb7e9d9b.png";